import { z } from 'zod'
import { incidentSearchSchema } from '@/features/incident-list'

export const clientProfileSearchSchema = incidentSearchSchema.extend({
  tab: z.coerce.string().optional(),
})

export type ClientProfileSearch = z.infer<typeof clientProfileSearchSchema>
